import { apiGet } from '@/lib/http/client';

import type { HubspotStatusResponse } from '../types';

export async function getHubspotStatus(
  orgId: number | string
): Promise<HubspotStatusResponse> {
  return apiGet<HubspotStatusResponse>(`/api/orgs/${orgId}/hubspot/status/`);
}
